import { Serializable } from '@admin/core/models/serializable';
import { MonthlyPlanItem } from './monthly-plan-item';
import { MonthlyPlanProductType } from './monthly-plan-product-type';

export class MonthlyPlan implements Serializable<MonthlyPlan> {
  public monthlyPlanId: number;
  public portfolioId: number;
  public year: number;
  public month: number;
  public totalDays: number;
  public workingDays: number;
  public holidays: number;
  public saturdays: number;
  public payments: number;
  public invoices: number;
  public sharesPlan: number;
  public lastChangeDate: Date;
  public isEditable: boolean;

  public monthlyPlanItems: MonthlyPlanItem[];
  public monthlyPlanProductTypes: MonthlyPlanProductType[];

  constructor() {
    this.monthlyPlanItems = [];
    this.monthlyPlanProductTypes = [];
  }

  fromObject(object: any): MonthlyPlan {
    if (!object) return null;
    Object.assign(this, object);

    this.monthlyPlanItems = [];
    this.monthlyPlanProductTypes = [];

    if (
      object.monthlyPlanItems &&
      object.monthlyPlanItems.length &&
      object.monthlyPlanItems.length > 0
    ) {
      object.monthlyPlanItems.forEach((d) => {
        let t = new MonthlyPlanItem();
        t = t.fromObject(d);
        this.monthlyPlanItems.push(t);
      });
    }

    if (
      object.monthlyPlanProductTypes &&
      object.monthlyPlanProductTypes.length &&
      object.monthlyPlanProductTypes.length > 0
    ) {
      object.monthlyPlanProductTypes.forEach((d) => {
        let t = new MonthlyPlanProductType();
        t = t.fromObject(d);
        this.monthlyPlanProductTypes.push(t);
      });
    }

    return this;
  }

  toObject() {
    let res = {
      MonthlyPlanId: this.monthlyPlanId,
      PortfolioId: this.portfolioId,
      Year: this.year,
      Month: this.month,
      TotalDays: this.totalDays,
      WorkingDays: this.workingDays,
      Holidays: this.holidays,
      Saturdays: this.saturdays,
      Payments: this.payments,
      Invoices: this.invoices,
      SharesPlan: this.sharesPlan,
      LastChangeDate: this.lastChangeDate,
      IsEditable: this.isEditable,
      MonthlyPlanItems: [],
      MonthlyPlanProductTypes: [],
    };

    this.monthlyPlanItems.forEach((i) => {
      res.MonthlyPlanItems.push(i.toObject());
    });
    this.monthlyPlanProductTypes.forEach((t) => {
      res.MonthlyPlanProductTypes.push(t.toObject());
    });

    return res;
  }
}
